import FormikInput from 'components/formikFields/input'
import FormikSelect from 'components/formikFields/select'
import Header from 'components/headers/addLoan'
import { Form, Formik } from 'formik'
import { NumericFormat } from 'react-number-format'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import useGetUnpaidSiblings from '../hooks/useGetunpaidSiblings'
import useUpdateInstallment from '../hooks/useUpdateInstallment'
import { toast } from 'react-toastify'

export default function EditInstallmentInLoan() {
    const { state } = useLocation()
    const { selectData } = useGetUnpaidSiblings()
    const { mutate } = useUpdateInstallment()
    const { moneyPool, loanId, installmentId } = useParams()
    const navigate = useNavigate()
    return (
        <Formik
            initialValues={{ amount: '', select: '' }}
            // validationSchema={Schema}
            onSubmit={async (values) => {
                if (selectData && selectData.length > 0) {
                    if (values.amount) {
                        const payload: {
                            source_instalment_id: string | undefined
                            destination_instalment_index: number
                            amount: number
                            moneyPools: string | undefined
                            loans: string | undefined
                        } = {
                            source_instalment_id: installmentId,
                            destination_instalment_index: Number(values.select),
                            amount: Number(values.amount),
                            moneyPools: moneyPool,
                            loans: loanId,
                        }
                        mutate(payload)
                    } else {
                        toast.error('مقدار کاهشی را وارد کنید')
                    }
                } else {
                    toast.error(
                        'این امکان با توجه به قسط های پرداختی وجود ندارد'
                    )
                    navigate(-1)
                }
            }}
        >
            {({
                submitForm,
                values,
                handleChange,
                errors,
                touched,
                setFieldValue,
            }) => (
                <Form className=" mx-1">
                    <div className=" h-screen flex flex-col">
                        <div className=" grow-0">
                            <Header title={`کاهش مبلغ قسط ${state.number}`} />
                        </div>
                        <div className=" grow mx-2">
                            <div className=" bg-green-2 py-3 rounded-md w-full flex justify-between px-2 text-sm  text-gray-1">
                                <p>مبلغ قسط {state.number}</p>
                                <p>
                                    {state.amount &&
                                        Number(
                                            state.amount
                                        ).toLocaleString()}{' '}
                                    تومان
                                </p>
                            </div>
                            <p className=" text-gray-1 text-sm my-2">
                                {' '}
                                مبلغی را که می خواهید از این قسط کاهش دهید و به
                                قسط دیگری اضافه کنید را وارد کنید.
                            </p>
                            <div className=" my-4">
                                <NumericFormat
                                    customInput={FormikInput}
                                    thousandSeparator
                                    placeholder="مبلغ را وارد کنید"
                                    allowNegative={false}
                                    name="amount"
                                    className="text-sm font-normal"
                                    label="مبلغ کاهشی"
                                    defaultValue={values.amount}
                                    secondaryTitle="| تومان "
                                    onValueChange={(values) => {
                                        const { value } = values
                                        setFieldValue('amount', value)
                                    }}
                                />
                            </div>
                            {selectData && selectData.length > 0 && (
                                <>
                                    <p className=" my-2 text-sm text-gray-1">
                                        یک قسط را برای اضافه کردن مبلغ کاهش
                                        یافته بالا به آن انتخاب کنید
                                    </p>
                                    <div className=" my-2">
                                        <FormikSelect
                                            name="select"
                                            label="انتخاب قسط"
                                            Options={selectData}
                                        />
                                    </div>
                                </>
                            )}
                        </div>
                        <div className=" grow-0 mx-2 my-2">
                            <button className=" w-full rounded-md text-white bg-green-1 py-2.5">
                                اعمال تغییرات
                            </button>
                        </div>
                    </div>
                </Form>
            )}
        </Formik>
    )
}
